import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "casa_blunt_session_token";

export const sessionToken = {
  get: () => {
    try { return localStorage.getItem(TOKEN_KEY); } catch (e) { return null; }
  },
  set: (token) => {
    try { localStorage.setItem(TOKEN_KEY, token); } catch (e) { /* storage blocked */ }
  },
  clear: () => {
    try { localStorage.removeItem(TOKEN_KEY); } catch (e) { /* storage blocked */ }
  },
};

// Helper for fetch() calls that need raw responses (file downloads — PDFs, ICS).
// Deliberately avoids `credentials: "include"` so we don't trigger the forbidden
// CORS combo of `Allow-Origin: *` + `Allow-Credentials: true` that some ingress
// configurations produce. Auth is carried by the Bearer header instead.
export const authFetch = (url, options = {}) => {
  const headers = { ...(options.headers || {}) };
  const t = sessionToken.get();
  if (t && !headers.Authorization) headers.Authorization = `Bearer ${t}`;
  return fetch(url, { ...options, headers });
};

export const api = axios.create({
  baseURL: API,
  // No `withCredentials` — we no longer rely on cookies for cross-origin auth.
  // The Authorization: Bearer header (injected below) carries the session
  // token. Same-origin requests still send cookies automatically (browser default).
});

// Inject Authorization header on every request when a session token is in
// localStorage. This is the fallback path for browsers that block third-party
// cookies (Chrome/Safari with strict cookie policy, custom-domain deploys, etc).
api.interceptors.request.use((config) => {
  const t = sessionToken.get();
  if (t) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${t}`;
    }
  }
  return config;
});

// Auto-clear the cached token on 401s so the user is bounced back to /login
// rather than getting stuck in a request loop with an invalid token.
api.interceptors.response.use(
  (resp) => resp,
  (err) => {
    if (err.response?.status === 401) {
      sessionToken.clear();
    }
    return Promise.reject(err);
  }
);
